module.exports = __webpack_public_path__ + "static/media/Bar_Inset@3x.554cbf11.png";